import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["images", "children"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import BaseImage from '../../../../../../atoms/Image';
import { ImagePropType } from '../../../../../../services/proptypes';
import { BaseCarouselPropTypes, BaseCarouselDefaultProps } from '../../../../../foundation/components/Carousel/types/base';
import BasicCarousel from '../../../../../foundation/components/Carousel/variants/BasicCarousel';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import './ImageCarousel.css';
var defaultProps = _objectSpread(_objectSpread({}, BaseCarouselDefaultProps), {}, {
  children: null,
  autoScroll: false,
  continuous: true,
  displayPlayPauseButton: false
});
export default function ImageCarousel(_ref) {
  var images = _ref.images,
    children = _ref.children,
    carouselProps = _objectWithoutProperties(_ref, _excluded);
  if (_isEmpty(images) && _isEmpty(children)) {
    return null;
  }
  if (_isEmpty(images) && !_isEmpty(children)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "image-carousel-container no-images"
    }, children);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "image-carousel-container"
  }, /*#__PURE__*/React.createElement(BasicCarousel, _extends({}, carouselProps, {
    size: 1,
    items: images.map(function (image) {
      return /*#__PURE__*/React.createElement(BaseImage, {
        key: JSON.stringify(image),
        src: image,
        background: true
      }, children);
    })
  })));
}
ImageCarousel.defaultProps = defaultProps;